"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductSpecsMultiColumnContainer;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _productSpecsMultiColumnContainerItem = _interopRequireDefault(require("./product-specs-multi-column-container-item"));
const RootContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RootContainer",
  class: "pl-r1vl733q"
});

/**
 * MultiColumnLayout Component.
 *
 * @param {Object} props React props
 * @param {Array} props.columns Array of columns (supports both rendered React components and plain objects)
 * @returns {React.ReactElement} MultiColumnLayout Component
 * @public
 */

function ProductSpecsMultiColumnContainer({
  columns
}) {
  if (!columns) return null;
  return /*#__PURE__*/_react.default.createElement(RootContainer, null, columns?.map((column, idx) => {
    return /*#__PURE__*/_react.default.isValidElement(column) ? column : /*#__PURE__*/_react.default.createElement(_productSpecsMultiColumnContainerItem.default, (0, _extends2.default)({
      key: idx
    }, column));
  }));
}
ProductSpecsMultiColumnContainer.propTypes = {
  columns: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array])
};